/* Exact Ali review counts on product cards (Hassan, 2026-09-26): Ali's card widget shows "4.4 (1.6k reviews)" and our
   fixed-height star row clipped it. We read the exact counts from Ali's public star-rating endpoint (the one its widget
   calls) and print "1615 reviews" (desktop) / "1615" (mobile via CSS) after the stars. Cards with 0 reviews show nothing. */
(() => {
  const API = 'https://pub.kudosi.ai/storefront/star-rating';
  const shop = (window.Shopify && Shopify.shop) || '9ee369-2.myshopify.com';
  const cache = {}; let pending = new Set(), timer;
  function paint(el) {
    const d = cache[el.getAttribute('product-id')];
    if (!d || !d.review_number) return;
    let s = el.querySelector(':scope > .imp-card-count');
    if (!s) { s = document.createElement('span'); s.className = 'imp-card-count'; el.appendChild(s); }
    const n = d.review_number.toLocaleString('en-US').replace(/,/g, '');
    const html = `${n}<span class="imp-card-count__label">review${d.review_number === 1 ? '' : 's'}</span>`;
    if (s.innerHTML !== html) s.innerHTML = html;
  }
  async function flush() {
    const ids = [...pending].filter((id) => !(id in cache)); pending = new Set();
    for (let i = 0; i < ids.length; i += 40) {
      const q = ids.slice(i, i + 40).map((id) => 'product_ids=' + id).join('&');
      try {
        const r = await (await fetch(`${API}?shop_domain=${encodeURIComponent(shop)}&${q}`)).json();
        Object.assign(cache, r.data || {});
        ids.slice(i, i + 40).forEach((id) => { if (!(id in cache)) cache[id] = null; });
      } catch (e) { /* leave the stars alone */ }
    }
    document.querySelectorAll('.imp-card-stars[product-id]').forEach(paint);
  }
  function scan() {
    document.querySelectorAll('.imp-card-stars[product-id]').forEach((el) => {
      const id = el.getAttribute('product-id');
      if (id in cache) paint(el); else pending.add(id);
    });
    if (pending.size) { clearTimeout(timer); timer = setTimeout(flush, 150); }
  }
  // Ali re-renders the widget's innerHTML on init, so re-paint whenever a card's star box changes
  new MutationObserver((muts) => {
    if (muts.some((m) => [...m.addedNodes].some((n) => n.nodeType === 1 && !n.closest('.imp-card-count')))) scan();
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();
